import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap'
import { Link } from 'react-router-dom'

export default class Form extends Component {
  render() {
    const { errorMessage } = this.props

    return (
      <form id="register" className="form-signin" onSubmit={this.handleSubmit}>
        <h2 className="form-signin-heading mt-3">Login</h2>
        <h6 className="form-signin-subheading">Sign In to your account</h6>
        <p>
          <label htmlFor="inputLoginEmail" className="sr-only">Email address</label>
          <input type="text" id="inputLoginEmail" className="form-control" placeholder="Email address" required autoFocus autoComplete="off"/>
        </p>
        <p>
          <label htmlFor="inputLoginPassword" className="sr-only">Password</label>
          <input type="password" id="inputLoginPassword" className="form-control" placeholder="Password" required autoComplete="off"/>
        </p>
        <p><button className="btn btn-primary" type="submit">LOGIN</button>
        <Link className="btn btn-link" to="/register">REGISTER</Link></p>
        {errorMessage ? <Alert color="danger">{errorMessage}</Alert> : null}
        {this.props.registration ? <Alert color="success">A confirmation mail has been sent to you.</Alert> : null }
      </form>
    )
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const creds = { email: event.target.inputLoginEmail.value.trim(), password: event.target.inputLoginPassword.value.trim() }
    this.props.onLoginClick(creds)
  }
}

Form.propTypes = {
  onLoginClick: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/containers/login/loginForm.js